/**
 * Helper function to perform a micro interaction animation on a 'Add to cart' button when a product is added to the cart.
 * @param {*} button Button to perform the micro interaction on
 */
export function addToCartBtnAnimation(button) {
    // Fallback if button is not defined
    if (!button) return;

    // Get the button's sub-elements
    const icon = button.querySelector(".btn__icon");
    const text = button.querySelector(".btn__text");

    // Hide the text and change the icon to a checkmark
    icon.classList.remove("icon-bold-shoppingCart");
    icon.classList.add("icon-bold-checkmark");
    text.style.display = "none";

    // The text won't be shown again and the icon changed because the item can only be added once to the cart.
}